import { http } from '@/api/httpAxios'
import { AxiosPromise } from 'axios'

export default class AuthAPI {
  public static getCurrentUser(): AxiosPromise {
    return http.get('/user/profile')
  }

  public static checkActivationCode(code: string): AxiosPromise {
    return http.get(`/auth/signup/${code}`)
  }

  public static register(params: any): AxiosPromise {
    return http.put('/auth/signup/', params)
  }

  public static login(params: any): AxiosPromise {
    return http.post('/auth/login/', params)
  }

  public static checkEmailForChangePassword(params: any): AxiosPromise {
    return http.put('/auth/password-change/set-code', params)
  }

  public static changePassword(params: any): AxiosPromise {
    return http.put('/auth/password-change', params)
  }
}
